import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23 5.001a4 4 0 0 1 3.995 3.8l.005.2V23a4 4 0 0 1-3.8 3.995L23 27H9.003a4 4 0 0 1-3.995-3.8l-.005-.2V9a4 4 0 0 1 3.8-3.995l.2-.005H23zm0 2H9.003a2 2 0 0 0-1.995 1.851l-.005.15v13.997a2 2 0 0 0 1.85 1.994l.15.006H23a2 2 0 0 0 1.995-1.851l.005-.15V9.002a2 2 0 0 0-1.85-1.994L23 7.001zm-6.999 11.962a1.192 1.192 0 1 1 0 2.384 1.192 1.192 0 0 1 0-2.384zM16.25 10c2.097 0 3.58 1.395 3.58 3.518 0 1.2-.592 2.05-1.73 2.706l-.673.367c-.335.187-.427.287-.424.85V18H15v-.984c0-1.088.512-1.653 1.746-2.332l.464-.247c.297-.168.619-.42.619-.919 0-.924-.687-1.518-1.58-1.518-.841 0-1.635.377-1.719.967l-.015.224v.39l-.497.61h-1.503v-1c0-1.854 1.695-3.191 3.734-3.191z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }